import { render } from "./ComponentUploadBusboy.vue?vue&type=template&id=5f0b58a8"
import script from "./ComponentUploadBusboy.vue?vue&type=script&lang=js"
export * from "./ComponentUploadBusboy.vue?vue&type=script&lang=js"

import exportComponent from "C:\\hd\\git\\enuve\\app-cliente\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__